import * as React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "components/ui/card";

interface ModernCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function ModernCard({
  title,
  description,
  children,
  className,
}: ModernCardProps) {
  return (
    <Card
      className={`relative overflow-hidden rounded-2xl 
      border border-gray-200/80 
      bg-white backdrop-blur-sm 
      shadow-lg
      ${className}`}
    >
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-primary/10 via-transparent to-primary/5 pointer-events-none" />

      <div className="relative z-10">
        <CardHeader className="pb-0">
          <CardTitle className="text-base font-bold text-gray-900">
            {title}
          </CardTitle>
          {description && (
            <CardDescription className="text-sm text-gray-500 ">
              {description}
            </CardDescription>
          )}
        </CardHeader>

        <CardContent className="pt-4 mt-5">{children}</CardContent>
      </div>
    </Card>
  );
}
